import ApiClient from '@/api/ApiClient';
import Certificate from '@/api/models/Certificate';

class UserCourseService {
    #prefixUrl = 'api/certificate/';

    constructor() {
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Gets Course certificate
     * @param {string} certificateUuid 
     */
    async find(certificateUuid = null) {
        const response = await this.api.executeRequest(`find/${certificateUuid}`, {}, this.api.methods.GET);

        let certificate = null;
        if (response.success()) {
            certificate = new Certificate(response.getContent());
            await certificate.certificate_assets.parseFiles();
        }

        return certificate;
    }
}

export default new UserCourseService();
